import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientInvoiceRow, InvoiceHistoryListDisplay, InvoiceHistoryModel } from '../../../models/InvoiceHistoryModels';
import { InvoiceHistoryService } from '../../../services/invoice-history.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SendInvoiceModalComponent } from '../dialogs/send-invoice-modal/send-invoice-modal.component';
import * as moment from 'moment';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { OneTimePaymentModalComponent } from '../one-time-payment-modal/one-time-payment-modal.component';

@Component({
  selector: 'app-invoice-history-list',
  templateUrl: './invoice-history-list.component.html',
  styleUrls: ['./invoice-history-list.component.less']
})
export class InvoiceHistoryListComponent implements OnInit {

  @Input() clientId: number;
  @Input() propertyId: number;
  @Input() displayType: InvoiceHistoryListDisplay;

  loading: boolean;
  sortDirection: boolean = true;
  fullView: boolean = false;

  constructor(public invoiceHistoryService: InvoiceHistoryService, public toast: ToastrService, public modalService: NgbModal, private http: HttpClient, private fileDownload: FileDownloadService) {
  }

  public ngOnInit(): void {

    this.invoiceHistoryService.invoiceList = [];
    this.loading = true;
    if (this.displayType === InvoiceHistoryListDisplay.Client) {
      // Load the Invoice History for this client
      this.invoiceHistoryService.loadInvoiceHistory(this.clientId);

    } else if (this.displayType === InvoiceHistoryListDisplay.Property) {
      // Load the invoice history for this property
      this.invoiceHistoryService.loadInvoiceHistory(this.propertyId, false);

    }

    else {
      //if the view isn't for a specific property OR client, then we're on the full view
      this.fullView = true;
      this.invoiceHistoryService.fetchInvoiceList();
    }

    this.invoiceHistoryService.$loadingInvoiceHistory.subscribe(res => this.loading = false);
  }

  public sendInvoice(e: ClientInvoiceRow): void {
    //SCRSTP-1459: needs to pop a modal where the user can specify the email address of the intended recipient
    const modalRef = this.modalService.open(SendInvoiceModalComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'SendInvoiceModalComponent';
    modalRef.componentInstance.invoice = e;
  }

  public makePayment(e: ClientInvoiceRow): void {
    if(e.paymentResponseId > 0) {
      this.toast.info('Payment has been processed for this invoice!', '');
      return;
    }
    this.http.get<any>(environment.baseURl + `/api/invoice/ns_check/${e.invoiceNumber}`).subscribe((rsp:any)=>{
      if(rsp.mapped){
        window.open(rsp.link.url,'_blank').focus();
      }
        else{
          // const modalRef = this.modalService.open(OneTimePaymentModalComponent, { centered: true, size: 'lg' });
          // modalRef.componentInstance.name = 'OneTimePaymentModalComponent';
          // modalRef.componentInstance.clientId = this.clientId > 0 ? this.clientId : e.clientId;
          // modalRef.componentInstance.propertyId = this.propertyId > 0 ? this.propertyId : e.clientLocationId;
          // modalRef.componentInstance.invoiceHistory = e;
          // modalRef.componentInstance.paymentProcessed.subscribe(evt => { 
          //   if(this.clientId) this.invoiceHistoryService.loadInvoiceHistory(this.clientId); 
          //   else if (this.propertyId) this.invoiceHistoryService.loadInvoiceHistory(this.propertyId, false); 
          // });
          this.toast.warning('No payment link found for this invoice. Please contact billing to process your payment.', '', { disableTimeOut: true, closeButton: true });
        }
    },()=>{
     
    })
  }

  public downloadInvoice(e: ClientInvoiceRow): void {
    this.invoiceHistoryService.DownloadInvoice(e.invoiceNumber).subscribe(res => {
      if (res) {
        this.fileDownload.HandleFileDownload(res, 'pdf', `${e.invoiceNumber}.pdf`);
      } else {
        this.toast.info('No invoice found.');
      }
    },
      err => this.toast.error('Error downloading invoice!', '', { disableTimeOut: true, closeButton: true }))
  }

  sortByKey(key: string) {
    this.loading = true;
    this.invoiceHistoryService.invoiceList.sort((a, b) => {
      if (this.sortDirection) {
        if (a[key] == b[key]) return 0;
        if (a[key] == null || a[key] == '') return 1;
        if (b[key] == null || b[key] == '') return -1;
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
      } else {
        if (a[key] == b[key]) return 0;
        if (a[key] == null || a[key] == '') return -1;
        if (b[key] == null || b[key] == '') return 1;
        if (a[key] > b[key]) return -1;
        if (a[key] < b[key]) return 1;
      }
    });
    this.sortDirection = !this.sortDirection;
    this.loading = false;
  }

  public FetchPropertyInvoiceList(clientId: number) {
    return this.http.get<ClientInvoiceRow[]>(environment.baseURl + `/api/invoice/property/list/${clientId}`);
  }
}

